module.exports = __webpack_public_path__ + "img/powered_by_flex.5eab83a9.svg";